import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';
import { AutorizadorService } from '../../../services/autorizador.service';

@Component({
    selector: 'app-lancamento-autorizador',
    templateUrl: './lancamento-autorizador.component.html',
    styleUrls: ['./lancamento-autorizador.component.css'],
    standalone: false
})
export class LancamentoAutorizadorComponent implements OnInit {
  autorizadorForm!: UntypedFormGroup;
  idautorizador = null;
  dataAutorizadorAtt = null;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private autorizadorService: AutorizadorService,
  ) { 
    this.autorizadorForm = this.newFormAutorizador();

    this.route.params.subscribe(res => this.idautorizador = res.idautorizador);
  }

  ngOnInit(): void {
    if (this.idautorizador !== undefined) {
      this.autorizadorService.detalhar(this.idautorizador).subscribe((p: any) => {
        let item = p.data.autorizador;
        this.dataAutorizadorAtt = item;
        this.autorizadorForm.get('idautorizador').setValue(item.idautorizador);
        this.autorizadorForm.get('nome').setValue(item.nome);
        this.autorizadorForm.get('telefone').setValue(item.telefone);
        this.autorizadorForm.get('site').setValue(item.site);
      });
    } else {
      this.autorizadorForm.reset();
    }
  }


  newFormAutorizador() {
    return new UntypedFormGroup({
      idautorizador: new UntypedFormControl(''),
      nome: new UntypedFormControl('', [Validators.required]),
      telefone: new UntypedFormControl(''),
      site: new UntypedFormControl(''),
    });
  }

  onSubmitAutorizador() {
    if (this.autorizadorForm.valid) {
      let id = this.message.loading('Salvando cadastro...').messageId;
      if (this.idautorizador !== undefined) {
        let dadosEdicao = this.autorizadorForm.value;

        this.autorizadorService.atualizar(dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/autorizador']);
          this.message.remove(id);
          this.message.success('O autorizador foi atualizado com SUCESSO!');
        });

      } else {
        this.autorizadorService.criar(this.autorizadorForm.value).subscribe((p: any) => {
          this.message.remove(id);
          this.router.navigate(['/autorizador']);
          this.message.success('O autorizador foi cadastrado com SUCESSO!');
        });
      }

    } else {
      for (const i in this.autorizadorForm.controls) {
        this.autorizadorForm.controls[i].markAsDirty();
        this.autorizadorForm.controls[i].updateValueAndValidity();
      }
    }
  }
}
